import * as i0 from '@angular/core';
import { Pipe, signal, effect, Directive, Input } from '@angular/core';
import { pathWalk, toWrapString, getExpressionTypes } from '@js-dot/core';
import { ToSelectOptionAccept, toSelectOption } from '@js-dot/form';
import { getRenderer } from '@js-dot/ui';
import { lazySet } from '@ng-dot/core';
class DotListDescriptionPipe {
  transform(item, adjust) {
    const {
      description
    } = adjust;
    const target = description['target'];
    let value = description['value'];
    if (value) {
      return value;
    } else if (!target) {
      return null;
    } else {
      value = item[target];
    }
    const {
      replace
    } = description;
    if (typeof replace === 'function') {
      return replace(value, item);
    }
    return value;
  }
  static ɵfac = function DotListDescriptionPipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotListDescriptionPipe)();
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "dotListDescription",
    type: DotListDescriptionPipe,
    pure: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListDescriptionPipe, [{
    type: Pipe,
    args: [{
      standalone: true,
      name: 'dotListDescription'
    }]
  }], null, null);
})();
class DotListLinkPipe {
  transform(item, adjust) {
    return adjust.route(item);
  }
  static ɵfac = function DotListLinkPipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotListLinkPipe)();
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "dotListLink",
    type: DotListLinkPipe,
    pure: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListLinkPipe, [{
    type: Pipe,
    args: [{
      standalone: true,
      name: 'dotListLink'
    }]
  }], null, null);
})();
class DotListValuePipe {
  transform(item, adjust) {
    const {
      value: {
        target,
        replace
      }
    } = adjust;
    if (!target) {
      if (adjust.value.component) {
        return item;
      }
      return null;
    }
    let value = pathWalk(item, target);
    if (typeof replace === 'function') {
      value = replace(value, item);
    }
    if (adjust.value.component) {
      return value;
    }
    switch (value) {
      case undefined:
      case null:
        return value;
    }
    switch (typeof value) {
      case 'boolean':
      case 'number':
      case 'string':
        return value;
      default:
        if (Array.isArray(value)) {
          return toWrapString(value, {
            firstStarts: '<ul>',
            starts: '<li>',
            ends: '</li>',
            lastEnds: '</ul>'
          });
        }
        return '<pre>' + JSON.stringify(value, null, 2) + '</pre>';
    }
  }
  static ɵfac = function DotListValuePipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotListValuePipe)();
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "dotListValue",
    type: DotListValuePipe,
    pure: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListValuePipe, [{
    type: Pipe,
    args: [{
      standalone: true,
      name: 'dotListValue'
    }]
  }], null, null);
})();
const _DOTS = /\./g;
/**
 * @see ListScriptOption
 */
class ListScriptBase {
  /**
   * @inheritDoc
   */
  listCheckbox;
  /**
   * @inheritDoc
   */
  listSort = false;
  /**
   * @inheritDoc
   */
  listFilter = false;
  /**
   * @inheritDoc
   */
  listSortDefault = true;
  /**
   * @inheritDoc
   */
  listFilterDefault = true;
}
class DotListComponentBase extends ListScriptBase {
  link;
  listKey;
  listCheckbox = undefined;
  listSort = true;
  listFilter = true;
  listDisplayFilter = true;
  listHeadings;
  listItems;
  listAdjusts;
  /**
   * @inheritDoc
   */
  listSorts;
  /**
   * @inheritDoc
   */
  listFilters;
  table = true;
  _listStableAdjust = false;
  listAdjusts$;
  listStableAdjusts$;
  listItems$;
  listHeadings$;
  listFilterTypes$;
  constructor() {
    super();
    const adjusts$ = signal(null);
    const items$ = signal(null);
    const headings$ = signal(null);
    const stableAdjusts$ = signal(null);
    const filterTextTypes$ = signal({});
    this.listAdjusts$ = adjusts$;
    this.listStableAdjusts$ = stableAdjusts$;
    this.listItems$ = items$;
    this.listHeadings$ = headings$;
    this.listFilterTypes$ = filterTextTypes$;
    effect(() => {
      const adjusts = adjusts$();
      const items = items$();
      let listHeadings = headings$();
      if (!adjusts || this._listStableAdjust) {
        return null;
      }
      if (!listHeadings) {
        if (this.listHeadings instanceof Promise) {
          return null;
        }
        listHeadings = {};
      }
      this._listStableAdjust = true;
      const {
        listSorts,
        listFilters,
        listSortDefault,
        listFilterDefault
      } = this;
      const stableAdjusts = [];
      const bulkSorts = listSorts || {};
      const bulkFilters = listFilters || {};
      const filterTypes = {};
      const end = adjusts.length;
      let current = -1;
      while (++current < end) {
        let adjust = adjusts[current];
        if (typeof adjust === 'string') {
          adjust = {
            value: {
              target: adjust
            },
            heading: {
              target: adjust
            }
          };
        } else {
          if (typeof adjust.value === 'string') {
            adjust.value = {
              target: adjust.value
            };
          }
          if (adjust.value['expressionAs']) {
            const expressionRenderer = getRenderer(adjust.value['expressionAs']);
            if (adjust.value['replace']) {
              const originReplace = adjust.value['replace'];
              adjust.value['replace'] = value => expressionRenderer(originReplace(value));
            } else {
              adjust.value['replace'] = expressionRenderer;
            }
          }
          if (!adjust.heading) {
            adjust.heading = {
              target: adjust.value['target']
            };
          } else if (typeof adjust.heading === 'string') {
            adjust.heading = {
              target: adjust.heading
            };
          }
          if (typeof adjust.description === 'string') {
            adjust.description = {
              target: adjust.description
            };
          }
          if (typeof adjust.filter === 'boolean') {
            if (adjust.filter) {
              adjust.filter = {
                type: 'search'
              };
            } else {
              // adjust.filter = {
              // }
            }
          }
        }
        const stableAdjust = adjust;
        const {
          value: {
            target
          }
        } = stableAdjust;
        if (!('key' in stableAdjust)) {
          stableAdjust['key'] = stableAdjust['value']['target'] || stableAdjust['value']['component']['dataTo'] || Object.keys(stableAdjust['value']['component']['dataAs'])[0];
        }
        const key = stableAdjust['key'];
        stableAdjust.key = stableAdjust['key'].replace(_DOTS, '_');
        if (!('filter' in stableAdjust)) {
          if (bulkFilters[target] || listFilterDefault) {
            adjust.filter = {
              type: 'search'
            };
          }
        } else {
          const filter = stableAdjust.filter;
          if (filter['type'] === 'select') {
            if (filter['numbers']) {
              filter['options'] = filter['numbers'];
              filter['optionsAccept'] = ToSelectOptionAccept.Number;
            } else if (filter['strings']) {
              filter['options'] = filter['strings'];
              filter['optionsAccept'] = ToSelectOptionAccept.String;
            }
            if (filter['options']) {
              filter['options'] = toSelectOption(filter['options'], filter['optionsAccept']);
            }
          }
        }
        if (stableAdjust.filter) {
          if (!stableAdjust.filter.target) {
            stableAdjust.filter.target = stableAdjust.value.target;
          }
        }
        if (!('sort' in stableAdjust)) {
          adjust.sort = bulkSorts[target] || listSortDefault;
        }
        stableAdjust.target = stableAdjust.value.target;
        stableAdjust.headingValue = stableAdjust.heading['value'] || listHeadings[stableAdjust.heading['target'] || key] || key;
        stableAdjust.eventType = stableAdjust.route && 'route' || stableAdjust.click && 'click' || false;
        stableAdjusts[stableAdjusts.length] = stableAdjust;
        if (stableAdjust.filter) {
          filterTypes[stableAdjust.target] = stableAdjust.filter['type'];
        }
      }
      if (items) {
        const expressionTypes = getExpressionTypes(items);
        current = -1;
        while (++current < end) {
          const adjust = stableAdjusts[current];
          const expressionType = expressionTypes[adjust.target];
          if (expressionType && !('expressionAs' in adjust.value) && !adjust.value.replace && !adjust.value.component) {
            adjust.value.replace = getRenderer(expressionType);
          }
        }
      }
      stableAdjusts$.set(stableAdjusts);
      filterTextTypes$.set(filterTypes);
    }, {
      allowSignalWrites: true
    });
  }
  ngOnChanges(changes) {
    for (let key in changes) {
      if (changes.hasOwnProperty(key)) {
        this[key] = changes[key].currentValue;
      }
    }
    if ('link' in changes) {
      const implementor = this['link'];
      this.listSort = implementor.listSort;
      this.listFilter = implementor.listFilter;
      if (implementor.hasOwnProperty('listSortDefault')) {
        this.listSortDefault = implementor.listSortDefault;
      }
      if (implementor.hasOwnProperty('listFilterDefault')) {
        this.listFilterDefault = implementor.listFilterDefault;
      }
      if (implementor.hasOwnProperty('listKey')) {
        this.listKey = implementor.listKey;
      }
      this.listCheckbox = implementor.listCheckbox;
      this.listHeadings = implementor.listHeadings;
      lazySet(this.listHeadings, this.listHeadings$);
      this.listAdjusts = implementor.listAdjusts;
      this._listStableAdjust = false;
      this.listAdjusts$.set(this.listAdjusts);
    }
    if ('listHeadings' in changes) {
      lazySet(this.listHeadings, this.listHeadings$);
    }
    if ('listItems' in changes) {
      this.listItems$.set(this.listItems);
    }
    if ('listAdjusts' in changes) {
      this._listStableAdjust = false;
      this.listAdjusts$.set(this.listAdjusts);
    }
  }
  listTrackBy(index, target) {
    return target[this.listKey] || index;
  }
  static ɵfac = function DotListComponentBase_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotListComponentBase)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotListComponentBase,
    inputs: {
      link: "link",
      listKey: "listKey",
      listCheckbox: "listCheckbox",
      listSort: "listSort",
      listFilter: "listFilter",
      listHeadings: "listHeadings",
      listItems: "listItems",
      listAdjusts: "listAdjusts",
      listSorts: "listSorts",
      listFilters: "listFilters",
      table: "table"
    },
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListComponentBase, [{
    type: Directive
  }], () => [], {
    link: [{
      type: Input
    }],
    listKey: [{
      type: Input
    }],
    listCheckbox: [{
      type: Input
    }],
    listSort: [{
      type: Input
    }],
    listFilter: [{
      type: Input
    }],
    listHeadings: [{
      type: Input
    }],
    listItems: [{
      type: Input
    }],
    listAdjusts: [{
      type: Input
    }],
    listSorts: [{
      type: Input
    }],
    listFilters: [{
      type: Input
    }],
    table: [{
      type: Input
    }]
  });
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotListComponentBase, DotListDescriptionPipe, DotListLinkPipe, DotListValuePipe, ListScriptBase };
